import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, useHistory } from 'react-router-dom';
import TablePage from './TablePage';
import SearchPage from './SearchPage';
import LoginPage, { LOGGED_IN_KEY } from './LoginPage';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import './Home.css';

const Home: React.FC<{theme: 'coffee'|'blue'}> = ({ theme }) => {
  const history = useHistory();
  const isLoggedIn = Boolean(localStorage.getItem(LOGGED_IN_KEY));
  // Ensure tab title is brand only on home page
  useEffect(() => { document.title = '普熏十方'; }, []);
  const searchIcon = (<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2"/><line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
  const hiddenIcon = (<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4C6 4 2 12 2 12s4 8 10 8 10-8 10-8-4-8-10-8z" fill="none" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" fill="currentColor"/></svg>);
  const coffeeCards = [
    { key:'audio', label:'音頻', to:'/table/audio', gradient:'linear-gradient(135deg,#e2c9b3,#c09268)', icon:(<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18V6l-4 4H2v4h3l4 4z" fill="currentColor"/><path d="M15 10a3 3 0 0 1 0 6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/><path d="M15 6a7 7 0 0 1 0 12" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>) },
    { key:'video', label:'視頻', to:'/table/video', gradient:'linear-gradient(135deg,#d3b59a,#b1875e)', icon:(<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h11a2 2 0 0 1 2 2v1l3.553-2.132A1 1 0 0 1 22 6.764v10.472a1 1 0 0 1-1.447.896L17 16v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" fill="currentColor"/></svg>) },
    { key:'text',  label:'文字', to:'/table/text',  gradient:'linear-gradient(135deg,#c8a58b,#a47954)', icon:(<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16v4H4zM4 10h16v2H4zM4 14h10v2H4zM4 18h8v2H4z" fill="currentColor"/></svg>) },
    { key:'search', label:'搜索', to:'/search', gradient:'linear-gradient(135deg,#d8bfa8,#9c7656)', icon: searchIcon },
    ...(isLoggedIn ? [{ key:'hidden', label:'出家師父專看，在家居士勿進', to:'/table/hidden', gradient:'linear-gradient(135deg,#8a7361,#4a3a2c)', icon: hiddenIcon }] : [])
  ];
  const blueCards = [
    { key:'audio', label:'音頻', to:'/table/audio', gradient:'linear-gradient(135deg,#c2e0ff,#5a8bd8)', icon:(<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18V6l-4 4H2v4h3l4 4z" fill="currentColor"/><path d="M15 10a3 3 0 0 1 0 6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/><path d="M15 6a7 7 0 0 1 0 12" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>) },
    { key:'video', label:'視頻', to:'/table/video', gradient:'linear-gradient(135deg,#b3d4ff,#4f7ec7)', icon:(<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h11a2 2 0 0 1 2 2v1l3.553-2.132A1 1 0 0 1 22 6.764v10.472a1 1 0 0 1-1.447.896L17 16v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" fill="currentColor"/></svg>) },
    { key:'text',  label:'文字', to:'/table/text',  gradient:'linear-gradient(135deg,#d0e7ff,#6b9fdc)', icon:(<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16v4H4zM4 10h16v2H4zM4 14h10v2H4zM4 18h8v2H4z" fill="currentColor"/></svg>) },
    { key:'search', label:'搜索', to:'/search', gradient:'linear-gradient(135deg,#c7ddf7,#5f8fd0)', icon: searchIcon },
    ...(isLoggedIn ? [{ key:'hidden', label:'出家師父專看，在家居士勿進', to:'/table/hidden', gradient:'linear-gradient(135deg,#7fa6d9,#3a5f8f)', icon: hiddenIcon }] : [])
  ];
  const cards = theme === 'coffee' ? coffeeCards : blueCards;
  return (
  <div className="home-wrapper">
      <header className="home-hero">
        <div className="home-hero-inner">
          <h1 className="home-title" aria-label="普熏十方">普熏十方</h1>
        </div>
      </header>
      <section className="home-cards" aria-label="分類選擇">
        {cards.map(c => (
          <button
            key={c.key}
            type="button"
            className="home-card"
            style={{ ['--card-bg' as any]: c.gradient }}
            onClick={() => history.push(c.to)}
            aria-label={`進入${c.label}分類`}
          >
            <span className="home-card-icon" aria-hidden="true">{c.icon}</span>
            <span className="home-card-label">{c.label}</span>
          </button>
        ))}
      </section>
    </div>
  );
};

// Simple placeholder pages
const VideoPage: React.FC = () => <div style={{padding:'40px'}}><h2 style={{color:'var(--main-coffee)'}}>視頻</h2></div>;
const AudioPage: React.FC = () => <div style={{padding:'40px'}}><h2 style={{color:'var(--main-coffee)'}}>音頻</h2></div>;
const TextPage: React.FC = () => <div style={{padding:'40px'}}><h2 style={{color:'var(--main-coffee)'}}>文字</h2></div>;

const App: React.FC = () => {
  const [theme] = useState<'coffee' | 'blue'>('blue');

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'coffee') {
      root.style.setProperty('--main-coffee', '#6f4e37');
      root.style.setProperty('--main-coffee-light', '#bfa08a');
      root.style.setProperty('--main-coffee-bg', '#f7f3f0');
      root.style.setProperty('--home-bg-start', '#f8f5f2');
      root.style.setProperty('--home-bg-mid', '#f1ebe7');
      root.style.setProperty('--home-bg-end', '#e9dfd8');
  root.style.setProperty('--theme-rgb', '111,78,55');
  // Table / breadcrumb surface colors (coffee theme)
  root.style.setProperty('--table-bg', '#ffffff');
  root.style.setProperty('--table-pagination-bg', '#faf7f5');
  root.style.setProperty('--table-chip-bg', '#f7f2ee');
  root.style.setProperty('--table-border-soft', '#e0d2c8');
  root.style.setProperty('--table-divider', '#f0e6de');
    } else {
      root.style.setProperty('--main-coffee', '#1e4e92');
      root.style.setProperty('--main-coffee-light', '#8bb4e3');
      root.style.setProperty('--main-coffee-bg', '#f2f7fc');
      root.style.setProperty('--home-bg-start', '#f5faff');
      root.style.setProperty('--home-bg-mid', '#e8f1fa');
      root.style.setProperty('--home-bg-end', '#d9e8f7');
  root.style.setProperty('--theme-rgb', '30,78,146');
  // Table / breadcrumb surface colors (blue theme)
  root.style.setProperty('--table-bg', '#ffffff');
  root.style.setProperty('--table-pagination-bg', '#eef5fb');
  root.style.setProperty('--table-chip-bg', '#e7f1fa');
  root.style.setProperty('--table-border-soft', '#cfdbec');
  root.style.setProperty('--table-divider', '#dbe7f2');
    }
  }, [theme]);

  return (
    <Router>
      <style>{`body { background: var(--main-coffee-bg) !important; margin:0; }`}</style>
      <div style={{minHeight:'100vh',display:'flex',flexDirection:'column'}}>
        <NavBar theme={theme} onToggleTheme={() => { /* toggle disabled */ }} />
  <main style={{flex:'1 0 auto',display:'flex',flexDirection:'column'}}>
        <Switch>
  <Route path="/" exact render={() => <Home theme={theme} />} />
        <Route path="/login" component={LoginPage} />
        <Route path="/search" component={SearchPage} />
        <Route path="/table" exact component={TablePage} />
        <Route path="/table/video" component={TablePage} />
        <Route path="/table/audio" component={TablePage} />
        <Route path="/table/text" component={TablePage} />
        <Route path="/table/hidden" component={TablePage} />
        <Route path="/video" component={VideoPage} />
        <Route path="/audio" component={AudioPage} />
        <Route path="/text" component={TextPage} />
        </Switch>
        </main>
        <Footer />
  </div>
    </Router>
  );
};

export default App;